<template>
  <Loading v-if="loading" />
  <div class="profile-changePassword">
    <div class="block-password">
      <p class="title">
        {{ $t('password') }}
      </p>
    </div>
    <p class="message">
      {{ $t('passwordCharacters') }}
    </p>
    <FormKit
      id="password-form"
      v-model="formData"
      type="form"
      :actions="false"
      :config="validationRules"
      @submit="submitHandler"
    >
      <PasswordInput
        name="password_current"
        model-value="password_current"
        :label="$t('currentPassword')"
        :validation="'required|length:8'"
        :validation-messages="{
          required: $t('validation.required'),
          length: $t('validation.lengthLong')
        }"
      />
      <PasswordInput
        name="password"
        :model-value="'password'"
        :label="$t('newPassword')"
        :validation="'required|length:8'"
        :validation-messages="{
          required: $t('validation.required'),
          length: $t('validation.lengthLong')
        }"
      />
      <PasswordInput
        name="password_confirm"
        model-value="password_confirm"
        :label="$t('confirmPassword')"
        :validation="'required|confirm'"
        :validation-messages="{
          required: $t('validation.required'),
          confirm: $t('validation.confirm')
        }"
      />
    </FormKit>
    <div class="buttons">
      <Button variant="filled" :title="$t('save')" @click="submitForm" />
      <Button
        variant="notBordered"
        :title="$t('cleanFields')"
        @click="cleanForm"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';
import { ChangePasswordData } from '@/store/modules/account/types';

@Options({
  name: 'ChangePassword',
  components: {
    Loading
  },
  data() {
    return {
      formData: {
        password_current: '',
        password: '',
        password_confirm: ''
      },
      validationRules: {},
      loading: false
    };
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    ...mapActions('account', ['changePasswordAdminProfile']),
    async submitHandler(data: ChangePasswordData) {
      this.loading = true;

      const payload = {
        ...data,
        newPassword: this.formData.password,
        repeatNewPassword: this.formData.password_confirm,
        oldPassword: this.formData.password_current
      };
      delete payload.password;
      delete payload.password_confirm;
      delete payload.password_current;

      await this.changePasswordAdminProfile(payload);
      this.$formkit.reset('password-form');
      this.loading = false;
    },
    submitForm() {
      this.$formkit.submit('password-form');
    },
    cleanForm() {
      this.$formkit.reset('password-form');
    }
  }
})
export default class ChangePassword extends Vue {}
</script>

<style lang="scss">
.profile-changePassword {
  .block-password {
    position: relative;
    margin-top: 40px;
    margin-bottom: 24px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $sixteenSize;
      color: $main-text;
    }
    &::after {
      content: '';
      position: absolute;
      top: 9px;
      left: 80px;
      width: 100%;
      height: 1px;
      background: $ligher-grey;
    }
    &::before {
      content: '';
      position: absolute;
      top: 7px;
      left: 80px;
      width: 5px;
      height: 5px;
      border-radius: 8px;
      background: $ligher-grey;
    }
  }
  .message {
    color: $label;
    font-size: $fourteenSize;
    line-height: 21px;
  }
  .formkit-form {
    width: 377px;
    margin-top: 32px;
    margin-bottom: 30px;
  }
  .buttons {
    padding-bottom: 20px;
  }
}
</style>
